import { render, staticRenderFns } from "./TickerAdminListServices.vue?vue&type=template&id=053d1c29&scoped=true"
import script from "./TickerAdminListServices.vue?vue&type=script&lang=js"
export * from "./TickerAdminListServices.vue?vue&type=script&lang=js"
import style0 from "./TickerAdminListServices.vue?vue&type=style&index=0&id=053d1c29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053d1c29",
  null
  
)

export default component.exports